module.exports = __webpack_public_path__ + "static/img/hoc.a918eff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hoc.jpg
// module id = /Sz+
// module chunks = 1